import React, { useEffect, useState, useMemo } from "react";
import { Helmet } from "react-helmet";
import { apiUrl } from '../constants'
import axios from 'axios'
import CardPhoto from '../components/card/CardPhotoToUseLocation';
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import chickenKoratImg from "../assets/img/chickenKorat.jpg"
import { useSelector } from 'react-redux';
import useCheckToken from '../hooks/useCheckToken';
import useExchangeToken from "../hooks/useExchangeToken";
import { useParams } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import RefreshIcon from "@mui/icons-material/RefreshRounded";
import { Button, Tooltip } from "@mui/material";
import moment from 'moment-timezone';
import Vietnam from '../assets/img/vietnam.jpg';

const CardPhotoMemo = React.memo(CardPhoto);

const LineList = () => {
  const today = new Date();
  const hourago = new Date(today.getTime());
  const date = moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD');
  const { bu, plant, factory } = useParams();
  const exchangeToken = useExchangeToken();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [line, setLine] = useState([]);
  const [factoryModules, setFactoryModules] = useState([]);
  const [isTokenExchanged, setIsTokenExchanged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatePO, setUpdatePO] = useState();
  const [notifyUpdatePOSuccessful, setNotifyUpdatePOSuccessful] = useState(false);
  const [notifyUpdatePOFailed, setNotifyUpdatePOFailed] = useState(false);
  const [updatingPO, setUpdatingPO] = useState(false);


  useCheckToken();
  const ac_token = useSelector(state => state.auth.access_token);
  const line_store = useSelector((state) => state.auth.line);
  const moduleGroup = useSelector((state) => state.auth.group);

  function storeCourse(name) {
    localStorage.setItem('line', name)
  }


  useEffect(() => {
    const fetchInitialTokenAndData = async () => {
      try {
        const token = await exchangeToken();
        if (token) {
          setIsTokenExchanged(true);
        }
      } catch (err) {
        console.error("Error exchanging token:", err);
        setError("Failed to exchange token");
      }
    };

    fetchInitialTokenAndData();
  }, [exchangeToken]);


  useEffect(() => {
    let active = true;
    const fetchMyAPI = async () => {
      if (!ac_token) return;
      setLine([]);
      setFactoryModules([]);
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl.MASTER_PLANT}${bu}/${plant}/${factory}`, {
          headers: {
            Authorization: `Bearer ${ac_token}`,

          },
        });

        if (active && response.status === 200) {
          setLine(response.data.LINE_MODULES || response.data.PLANT || []);
          setFactoryModules(response.data.FACTORY_MODULES || []);
        }
      } catch (err) {
        if (active) setError(err.message);
        console.error("Error fetching Line data:", err);
      } finally {
        if (active) setLoading(false);
      }
    };

    if (isTokenExchanged && ac_token) {
      fetchMyAPI(); 
    }
    return () => { active = false; };
  }, [isTokenExchanged, ac_token, bu, plant, factory]);

  const api = () => {
    const specialPlants = ['B425'];
    return specialPlants.includes(plant)
      ? apiUrl.UPDATE_PO_V2_VN
      : apiUrl.UPDATE_PO_V2;
  };

  const factoryCode = () => {
    const specialPlants = ['4071', '4116', '4117', '4070', '4003', '4087'];
    return specialPlants.includes(plant)
      ? '00000000000000'
      : factory;
  };


  const handleUpdatePO = async () => {
    if (updatingPO) return;

    try {
      setUpdatingPO(true);

      console.log({
        plant_id: plant,
        factory: factoryCode(),
        plan_date: date,
      });

      const response = await axios.post(
        `${api()}`,
        {
          plant_id: plant,
          factory: factoryCode(),
          plan_date: date,
        },
        {
          headers: {
            Authorization: `Bearer ${ac_token}`,
          },
        }
      );

      if (response.status === 200) {
        setUpdatePO(1);
        setNotifyUpdatePOSuccessful(true);
      } else {
        setUpdatePO(2);
        setNotifyUpdatePOFailed(true);
      }
    } catch (error) {
      if (error.code === "ECONNABORTED" || error.response?.status === 504) {
        setUpdatePO(1);
        setNotifyUpdatePOSuccessful(true);
      } else {
        setUpdatePO(2);
        setNotifyUpdatePOFailed(true);
      }
    } finally {
      setUpdatingPO(false);
    }
  };


  line.sort((a, b) => {
    if (a.length !== b.length) {
      return a.length - b.length;
    }
    return a.localeCompare(b);
  });

  // const filterBUData = (line_store, line_from_api) => {
  //   if (line_store === "All") {
  //     return line_from_api;
  //   } else if (line_store === "None") {
  //     return line_from_api;
  //   } else if (line_store === "-") {
  //     return line_from_api;
  //   }
  //   return line_from_api.filter((item) => item === line_store);
  // };

  const filterBUData = (line_store, line_from_api = []) => {
    const value = (line_store ?? "").trim().toLowerCase();

    if (
      value === "all" ||
      value === "none" ||
      value === "-"
    ) {
      return line_from_api;
    }

    return line_from_api.filter(
      (item) => String(item).toLowerCase() === value
    );
  };

  const imageMap = {
    "4117": chickenKoratImg,
    "B425": Vietnam,
  };
  
  const getImageByPlant = (name) => imageMap[name] ?? chickenKoratImg;
  

  const lineData = useMemo(() => {
    const filteredBu = filterBUData(line_store, line);
    return filteredBu.length === 0
      ? []
      : filteredBu.map((name, index) => ({
          key: index,
          name,
          fileLocation: getImageByPlant(plant),
        }));
  }, [line, line_store, plant]);
  




  return (
    <Box style={{ width: "100%", height: "90vh" }}>
      <Helmet>
        <title>Line List | MES</title>
      </Helmet>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Box
            m='1%'
            display="flex"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows={"100%"}
            columnGap="1%"
            rowGap="6%"
            pl={1}
          >
            {lineData.length > 0 && <Tooltip title="Update PO">
              <Button
                onClick={handleUpdatePO}
                disabled={updatingPO}
                startIcon={
                  <RefreshIcon
                    sx={{
                      animation: updatingPO ? "spin 1s linear infinite" : "none",
                      "@keyframes spin": {
                        "100%": { transform: "rotate(360deg)" },
                      },
                    }}
                  />
                }
                sx={{
                  backgroundColor: "#43C6C6",
                  color: "#fff",
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: "8px",
                  px: 2.5,
                  py: 0.8,
                  minWidth: 130,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  "&:hover": {
                    backgroundColor: "#2FB3B3",
                    boxShadow: "0 6px 14px rgba(0,0,0,0.2)",
                  },
                  "&:disabled": {
                    backgroundColor: "#43C6C6",
                    opacity: 0.7,
                    color: "#fff",
                  },
                }}
              >
                {updatingPO ? "Updating..." : "Update"}
              </Button>
            </Tooltip>}

          </Box>
        </Grid>
        <Grid item xs={12} sm={12} >
          <Box
            m='1%'
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows={lineData.length > 6 ? "50%" : "100%"}
            gap="3%"
            mt={-1}
          >
            {/* ESTIMATED */}
            {filterBUData(moduleGroup, factoryModules).map(name => (
              <Box key={name} gridColumn="span 2" display="flex" alignItems="center" justifyContent="center">
                <CardPhotoMemo name={name} fileLocation={getImageByPlant(plant)} />
              </Box>
            ))}
            {lineData.map((item) => (
              <Box
                key={item.key || item.id}
                gridColumn="span 2"
                display="flex"
                alignItems="center"
                justifyContent="center"
                onClick={() => storeCourse(item.name)}
              >
                <CardPhotoMemo name={item.name} fileLocation={item.fileLocation || chickenKoratImg} />
              </Box>
            ))
            }
          </Box>
        </Grid>
      </Grid>
      {updatePO == 1 ?
        <div style={{ marginTop: 20 }}>
          <Dialog
            open={notifyUpdatePOSuccessful}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description" minWidth='200px' align='center'>
                Successfully update PO
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button style={{ backgroundColor: '#009688' }} variant="contained" onClick={() => { setNotifyUpdatePOSuccessful(false); }}>OK</Button>
            </DialogActions>
          </Dialog>

        </div>
        : console.log()
      }
      {updatePO == 2 ?
        <div style={{ marginTop: 20 }}>
          <Dialog
            open={notifyUpdatePOFailed}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description" minWidth='200px' align='center'>
                Failed to update PO, Plead try again
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button style={{ backgroundColor: '#009688' }} aligh='Center' variant="contained" onClick={() => { setNotifyUpdatePOFailed(false); }}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        : console.log()
      }
    </Box>
  )
}

export default LineList
